import {useMutation} from '@tanstack/react-query';
import subscriptionUpdaters from '@/api/updaters/content-studio/subscription';

function useContentStudioChangeSubscriptionMutation() {
  return useMutation({
    mutationFn: ({
      paymentSourceId,
      selectedPlanId,
      isDryRun,
    }: {
      paymentSourceId: string;
      selectedPlanId: string;
      isDryRun: boolean;
    }) =>
      subscriptionUpdaters.changeSubscription(
        paymentSourceId,
        selectedPlanId,
        isDryRun
      ),
  });
}

export default useContentStudioChangeSubscriptionMutation;
